import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {


    useEffect(() => {
        window.scrollTo(0, 0)

    }, []);




        return (
            <div>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link> <span className="mx-2 mb-0">/</span> <strong className="text-black">Order Cancellation Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{width : "99% " ,padding : "30px 30px"}}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{fontWeight :"bold"}}>
                                {/* <h2>This Privacy Policy</h2> */}
                                <h1>Order Cancellation Policy</h1>
    <p>
        You may cancel your order at any time before the order has been processed. Once the product has been shipped, the order cannot be cancelled, and our "Exchange Policy" will apply.
    </p>
    <p>
        MALOOK may cancel orders for reasons including but not limited to: 
    </p>
    <ul>
        <li>The item is out of stock.</li>
        <li>Price errors.</li>
        <li>The credit card payment is declined by the issuing financial institution.</li>
    </ul>

    <div class="note">
        <strong>Note:</strong> Please ensure to review your order carefully before finalizing your purchase to avoid any cancellation issues.
    </div>

                                </div>
                            </div>
                        </div>
                </div>
            </div>
        )
    
}


export default Contact;